export type Surface = 'app' | 'marketing';

/**
 * Decide which bundle to load based on hostname.
 *
 * Production:
 *   app.workinbox.app           → 'app'
 *   workinbox.app               → 'marketing'
 *   marketing.workinbox.app     → 'marketing'
 *
 * Dev (localhost):
 *   default                     → 'marketing'
 *   ?surface=app                → 'app' (override for testing wizard locally)
 *   ?surface=marketing          → 'marketing' (explicit)
 */
export function resolveSurface(hostname: string, search = ''): Surface {
  const params = new URLSearchParams(search);
  const override = params.get('surface');

  // Dev override via query string (localhost OR Cloudflare Pages preview URLs)
  const isLocal =
    hostname === 'localhost' || hostname === '127.0.0.1' || hostname.startsWith('192.168.');
  const isPagesPreview = hostname.endsWith('.pages.dev');
  if (isLocal || isPagesPreview) {
    if (override === 'app') return 'app';
    if (override === 'marketing') return 'marketing';
    return 'marketing';
  }

  // Production: any "app." subdomain → app
  if (hostname.startsWith('app.')) return 'app';

  // Everything else (apex domain, marketing subdomain, etc.) → marketing
  return 'marketing';
}
